import React from "react";
import PropTypes from "prop-types";
import ConnectedReceiptDetailsGifts from "./ConnectedReceiptDetailsGifts";
import ConnectedReceiptDetailsParticipants from "./ConnectedReceiptDetailsParticipants";
import ConnectedReceiptTotal from "./ConnectedReceiptTotal";
import ConnectedReceiptDetailsStore from "./ConnectedReceiptDetailsStore";

const ReceiptDetails = ({ receiptId, controlId, showTotal }) => (
    <>
        <ConnectedReceiptDetailsParticipants controlId={controlId} />

        <ConnectedReceiptDetailsStore controlId={controlId} />

        <ConnectedReceiptDetailsGifts controlId={controlId} />
        {showTotal && (
            <div className="col col--12 col--no-top-gutter">
                <ConnectedReceiptTotal
                    receiptId={receiptId}
                    controlId={controlId}
                />
            </div>
        )}
    </>
);

ReceiptDetails.propTypes = {
    controlId: PropTypes.number.isRequired,
    receiptId: PropTypes.string.isRequired,
    showTotal: PropTypes.bool.isRequired,
};

export default ReceiptDetails;
